import { render, staticRenderFns } from "./InstructionalDesignCard.vue?vue&type=template&id=44714464&scoped=true"
import script from "./InstructionalDesignCard.vue?vue&type=script&lang=js"
export * from "./InstructionalDesignCard.vue?vue&type=script&lang=js"
import style0 from "./InstructionalDesignCard.vue?vue&type=style&index=0&id=44714464&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44714464",
  null
  
)

export default component.exports